import mainLogo from '../../images/Carlider/logo_carlider_color.png';
import squareLogo from '../../images/Carlider/favicon-carlider.png';
import bannerLogoWhite from '../../images/Carlider/logo_carlider_branco.png';
import banner01 from '../../images/Carlider/CarLider_Banner_01_bg.jpg';
import banner02 from '../../images/Carlider/CarLider_Banner_03_bg.jpg';
import banner03 from '../../images/Carlider/CarLider_Banner_02_bg_02.jpg';
import banner04 from '../../images/Carlider/banner_carlider_02.webp';
import imgSpecial from '../../images/Carlider/CarLider_Banner_01_img.png';
import imgSpecial2 from '../../images/Carlider/CarLider_Banner_02_img.png';
import step1img from '../../images/Carlider/CarLider_Banner_02_step01.jpg';
import step2img from '../../images/Carlider/CarLider_Banner_02_step02.jpg';
import step3img from '../../images/Carlider/CarLider_Banner_02_step03.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Carlider',
    defaultStoreLink: 'pecas.carlider.com.br',
    defaultContactEmail: 'suporte@carlider.com.br',
    whatsappNumber: '21 98458 6921',
    CNPJname: '',
    CNPJ: '',
    CNPJaddress: '',
    launchDate: '19/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "fiat",
        "volkswagen",
        "toyota",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "RECREIO BH VW",
        "RECREIO RJ VW",
        'SULPAR SGA TOYOTA - HAUER',
        'SULPAR SGA TOYOTA - NITEROI',
        'VITORIAWAGEN SERRA',
        'ORLY FIAT BETIM',
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: '',
    car123: '',
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerSpecial: banner01,
    bannerSpecialMobile: banner01,
    imgSepcial: imgSpecial,
    imgSepcialMobile: imgSpecial,

    imgSpecial2: imgSpecial2,

    step1img: step1img,
    step2img: step2img,
    step3img: step3img,

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Carlider</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Carlider é a plataforma de negócios do Grupo Lider onde você poderá encontrar todos os veículos comercializados, sejam eles Novos e Seminovos, além de avaliar o seu veículo usado e adquirir Peças e Acessórios originais das marcas que representamos.',
            'Há mais de 60 anos, o Grupo Lider possui uma enorme atuação no segmento de concessionárias de automóveis e motocicletas e é um dos maiores grupos do país com mais de 70 lojas nos estados do Rio de Janeiro, Minas Gerais e Espírito Santo.',
            'Representamos as marcas Volkswagen, Chevrolet, Toyota, Fiat, Jeep, Hyundai, Ford e Honda Motos. Além de veículos seminovos multimarcas de alta qualidade que são rigorosamente inspecionados pelos profissionais do Grupo Lider.'

        ],
        link: 'https://www.carlider.com.br/quem-somos/carlider',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/carlider.br/',
        Facebook: 'https://www.facebook.com/carlider.br',
        LinkedIn: '',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}